export default {"src":"/_next/static/media/information-meet-before.edaa21a8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};